import { createSelector } from 'reselect';

import { reportDataTableAgGridSelector } from '../state/reportDataTableAgGridState';

export const selectSelectedAgGridColumn = createSelector(reportDataTableAgGridSelector, (state) => state.activeColumn);

export const selectFilterValuesByColumn = createSelector(
  reportDataTableAgGridSelector,
  (state) => state.filterValuesByColumn
);
